module.exports = "<app-layout>\n  <!-- app inhalt wird hier eingefuegt -->\n</app-layout>\n"